module.exports = __webpack_public_path__ + "img/Edit (1).e05fac00.svg";